import { useContext } from 'react'
import { ExternalLink } from '../../../assets/external-link'
import { ListSnippetItem } from '../list-snippet-item/list-snippet-item'
import { SharedUiHeaderV2Context } from '../../context/context-shared-ui-header-v2'
import { NavItemSnippet } from '../../../data/shared'

interface ListSnippetMapperProps {
  snippets: NavItemSnippet[]
  label: string
  isMobile?: boolean
}

export const ListSnippetMapper = ({
  snippets,
  label,
  isMobile,
}: ListSnippetMapperProps) => {
  const { logicStore } = useContext(SharedUiHeaderV2Context)

  const { handleTrackEvent } = logicStore

  return snippets.map((snippet) => (
    <ListSnippetItem
      key={snippet.heading}
      isMobile={isMobile}
      heading={snippet.heading}
      snippet={snippet.snippet}
      linkText={snippet.linkText}
      href={snippet.href}
      image={snippet.image}
      alt={snippet.alt}
      {...(snippet.externalLink && { customIcon: <ExternalLink /> })}
      handleTrackEvent={() =>
        handleTrackEvent({
          name: 'click',
          category: 'mega menu',
          label,
          action: snippet.trackingAction,
          value: snippet.linkText,
        })
      }
      useReducedWidthSnippet={true}
    />
  ))
}
